import "core-js";
import "regenerator-runtime/runtime";
import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";

import $ from "jquery";
import "jquery-serializejson";
import svg4everybody from "svg4everybody";
import "objectFitPolyfill";
import "base/focus-within-polyfill"

import Page from "webPage/Page";
import {handleNav} from "util/nav";

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    document.documentElement.setAttribute('data-useragent', navigator.userAgent);
    if (!!window.MSInputMethodContext && !!document.documentMode) {
        $('html').addClass('ie11');
    }

    svg4everybody();
    handleNav();

    Page.init();


    $('body').on('change', '.gfield input, .gfield .textarea, .gfield .gfield_select', function(){
        if($(this).val() !== ""){
            $(this).parents('.gfield').addClass('gfield--active');
        } else {
            $(this).parents('.gfield').removeClass('gfield--active');
        }
    }).on('click', '.js-open-modal', function () {
        $("body").addClass('modal-active');
        $(".js-modal").addClass('modal--active');
    }).on('click', '.js-close-modal', function () {
        $("body").removeClass('modal-active');
        $(".js-modal").removeClass('modal--active');
    });
});

export function svg_include(icon, suffix = '') {
    return '<svg><use xlink:href="/wp-content/themes/avongard/includes/svg-icons.svg?#' + icon + '"></use></svg>';
}

window.$ = window.jQuery = $;
window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;
